import {IPlayerStore} from './player.interface';

export const playerStoreInitialState: IPlayerStore = {
  nowPlaying: null
};
